import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { mainDetail, termsConfig } from './../request';
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      columns: [{
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '展示格式'
        },
        dataIndex: 'display',
        key: '2',
        align: 'center',
        scopedSlots: {
          customRender: 'display'
        },
        width: 200
      }, {
        slots: {
          title: '阅读限制'
        },
        dataIndex: 'limit',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'limit'
        },
        width: 200
      }, {
        slots: {
          title: '强制阅读时间'
        },
        dataIndex: 'time',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'time'
        },
        width: 200
      }],
      id: '',
      templateId: ''
    };
  },
  methods: {
    init(id) {
      this.id = id;
      mainDetail({
        insuranceId: id
      }).then(res => {
        this.list = res.termsConfig.termsConfig;
        this.templateId = res.termsTemplateId;
        this.list.map(item => {
          item.terms.map(item2 => {
            if (item2.display == 0) {
              item2.display = 1;
            }
            if (item2.limit == 0) {
              item2.limit = undefined;
            }
            if (item2.time == 0) {
              item2.time = '';
            }
          });
        });
        console.log(this.list);
        this.dialogVisible = true;
      });
    },
    handleSure() {
      let arr = [],
        arr3 = [];
      this.list.map(item => {
        let obj = {
          index: item.index,
          mark: item.mark,
          name: item.name,
          terms: []
        };
        item.terms.map(item2 => {
          if (item2.limit == 3) {
            arr3.push(item2);
          }
          let obj2 = {
            display: item2.display || 0,
            limit: item2.limit || 0,
            name: item2.name,
            termsId: item2.termsId,
            time: item2.time || 0
          };
          obj.terms.push(obj2);
        });
        arr.push(obj);
      });
      if (arr3.length != 0) {
        let arr4 = arr3.filter(item => item.time);
        if (arr4.length != arr3.length) {
          this.$message.error(this.$t('阅读限制为强制阅读时,阅读时间必填'));
          return false;
        }
      }
      termsConfig({
        insuranceId: this.id,
        termsConfig: JSON.stringify({
          templateId: this.templateId,
          termsConfig: arr
        })
      }).then(res => {
        console.log(res, 55);
        this.$message.success(this.$t('配置成功') + '!');
        this.$emit('cancel');
        this.$emit('ok');
      });
    },
    displayChange(index, index2) {
      console.log(index, index2);
      this.list[index].terms[index2].time = '';
    }
  }
};